import { getUser } from './persist';

export const hasRole = (role) => {
  return getUser()?.roles.includes(role);
};
